/**
 * Publications-only org: seat license `Publications`, and/or portal classification fields.
 * Prefer seatLicenseType going forward; portalType/type/organizationTypes kept for compatibility.
 */
export function organizationIsPublications(organization) {
  if (!organization) return false
  const seatLicenseType = String(organization?.seatLicenseType || '').trim().toLowerCase()
  if (seatLicenseType === 'publications') return true
  const portalType = String(organization?.portalType || '').trim().toLowerCase()
  const type = String(organization?.type || '').trim().toLowerCase()
  if (portalType === 'publications' || type === 'publications') return true
  const types = Array.isArray(organization?.organizationTypes) ? organization.organizationTypes : []
  return types.some((value) => String(value || '').trim().toLowerCase() === 'publications')
}
